export default [
    {
        path: '/admin/academic/skill-profiles',
        name: 'skill-profile',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/skill-profile/index.vue')
    }
]
